const accountActivityUrl = "v1/credit/accounts/activity";
export {
  accountActivityUrl
};
//# sourceMappingURL=endpoints.js.map
